import React, { useState, useEffect, memo } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "../ImageGallery.css";
import FabricIcons from "./FabricIcons";
import FabricInfo from "./FabricInfo";
import {
	ULTRASONIC_REQUIRED,
	HAVE_SET,
	SOUND_ABSORPTION,
	REFLECTIVE_BACKING,
} from "../constants/fabricData";

const FabricCard = memo(({ fabricData, seriesData, selectedShade }) => {
	const [currentSKU, setCurrentSKU] = useState(fabricData[0]?.SKU || "");

	useEffect(() => {
		setCurrentSKU(fabricData[0]?.SKU || "");
	}, [fabricData]);

	const handleSlide = (currentIndex) => {
		setCurrentSKU(fabricData[currentIndex]?.SKU || "");
	};

	return (
		<div className="w-full flex flex-wrap justify-center px-2 max-xl:block max-xl:mx-auto max-xl:px-0">
			<div className="w-1/3 max-xl:w-full">
				<ImageGallery
					items={fabricData}
					showFullscreenButton={false}
					showThumbnails={true}
					showPlayButton={false}
					renderThumbInner={(item) => (
						<img src={item.thumbnail} alt={item.originalAlt} loading="lazy" />
					)}
					infinite={true}
					disableThumbnailScroll={true}
					onSlide={handleSlide}
				/>
			</div>
			<div className="w-1/3 px-14 mt-4 flex-col max-xl:w-1/2 max-xl:mx-auto max-lg:w-2/3 max-md:w-full max-lg:px-8">
				{selectedShade !== "simply cellular" && (
					<div>
						<h4 className="text-xl font-bold text-left">Special Features</h4>
						<FabricIcons
							fabricData={fabricData}
							selectedShade={selectedShade}
							seriesData={seriesData}
							ultrasonicRequired={ULTRASONIC_REQUIRED}
							haveSet={HAVE_SET}
							reflectiveBacking={REFLECTIVE_BACKING}
							soundAbsorption={SOUND_ABSORPTION}
						/>
					</div>
				)}
				<FabricInfo fabricData={fabricData} currentSKU={currentSKU} />
			</div>
		</div>
	);
});

FabricCard.displayName = "FabricCard";

export default FabricCard;
